import { isAfter, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import packageJson from "../package.json";

const buildDateGreaterThan = (latestDate, currentDate) => {
  const dateFnsLatestDate = parseISO(latestDate);
  const dateFnsCurrentDate = parseISO(currentDate);

  return isAfter(dateFnsLatestDate, dateFnsCurrentDate);
};

function withClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

    useEffect(() => {
      fetch("/meta.json")
        .then((response) => response.json())
        .then((meta) => {
          const latestVersionDate = meta.buildDate;
          const currentVersionDate = packageJson.buildDate;
          // console.log("latestVersionDate", latestVersionDate);
          // console.log("currentVersionDate", currentVersionDate);

          const shouldForceRefresh = buildDateGreaterThan(
            latestVersionDate,
            currentVersionDate
          );
          if (shouldForceRefresh) {
            // console.log("shouldForceRefresh", shouldForceRefresh);
            setIsLatestBuildDate(false);
            refreshCacheAndReload();
          } else {
            setIsLatestBuildDate(true);
          }
        });
    }, []);

    const refreshCacheAndReload = () => {
      console.log("Clearing cache and hard reloading...");
      if (caches) {
        console.log("Clearing service worker cache...");
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then((names) => {
          for (const name of names) {
            console.log("Clearing cache: ", name);
            caches.delete(name);
          }
        });
      }
      // delete browser cache and hard reload
      window.location.reload(true);
    };

    return (
      <React.Fragment>
        {isLatestBuildDate ? <Component {...props} /> : null}
      </React.Fragment>
    );
  }

  return ClearCacheComponent;
}

export default withClearCache;
